import { useStaticQuery, graphql } from 'gatsby'

export const useServiceAreasQuery = () => {
  const { wpPage } = useStaticQuery(graphql`
    query ServiceAreasQuery {
      wpPage(title: { eq: "Home" }) {
        serviceAreas {
          serviceAreas {
            backgroundImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, formats: [WEBP])
                }
              }
            }
            backgroundImageMobile {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, formats: [WEBP])
                }
              }
            }
            imageOverlay {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, formats: [WEBP])
                }
              }
            }
            imageOverlayAltText
            title
            locationIcon {
              localFile {
                publicURL
              }
            }
            states {
              stateName
              services {
                serviceName
                counties {
                  countyName
                  mapImage {
                    localFile {
                      childImageSharp {
                        gatsbyImageData(layout: FULL_WIDTH, formats: [WEBP])
                      }
                    }
                  }
                  mapImageAltText
                  townLinks
                }
              }
            }
            countiesAndTowns {
              county
              towns
            }
          }
        }
      }
    }
  `)
  return wpPage.serviceAreas.serviceAreas
}
